export default __webpack_public_path__ + "static/media/attraqt-logo.ecd9aba4.svg";